import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import AttachmentUpload from 'components/AttachmentUpload'
import { selectTicketDraftAttachments } from 'selectors/attachments'
import { selectAttachmentsByDraftId } from 'ducks/drafts2/selectors'
import { getLength } from 'util/arrays'
import IconWithTooltip from './IconWithTooltip'

class AttachmentIcon extends React.Component {
  openAttachmentDialog = () => {
    const { onClick } = this.props
    if (onClick) onClick()
    document.getElementById(this.props.triggerId).click()
  }

  render() {
    const {
      dispatch,
      forNote,
      hasAttachments,
      triggerId,
      draftId,
      icon,
      onUploadComplete,
      ...rest
    } = this.props

    const tooltipProps = {
      tooltip: 'Add attachments',
      position: 'top',
    }

    const Icon = icon ? (
      React.cloneElement(icon, { withTooltip: tooltipProps })
    ) : (
      <IconWithTooltip
        name="attachment"
        tooltip={tooltipProps.tooltip}
        tooltipPosition={tooltipProps.position}
        {...rest}
      />
    )

    return (
      <React.Fragment>
        {React.cloneElement(Icon, {
          active: hasAttachments,
          onClick: this.openAttachmentDialog,
        })}
        <AttachmentUpload
          forNote={forNote}
          hideIcon
          triggerId={triggerId}
          draftId={draftId}
          onUploadComplete={onUploadComplete}
        />
      </React.Fragment>
    )
  }
}

AttachmentIcon.propTypes = {
  triggerId: PropTypes.string,
  icon: PropTypes.element,
}

AttachmentIcon.defaultProps = {
  triggerId: 'attachmentUploadTrigger',
  icon: null,
}

const selectFactory = (initialState, initialOwnProps) => {
  // eslint-disable-next-line no-prototype-builtins
  if (initialOwnProps.hasOwnProperty('draftId')) {
    return (state, props) => {
      const draftAttachments = selectAttachmentsByDraftId(state, props.draftId)
      return {
        hasAttachments: draftAttachments && draftAttachments.length > 0,
      }
    }
  }

  return state => {
    return {
      hasAttachments: getLength(selectTicketDraftAttachments(state)) > 0,
    }
  }
}

export default connect(selectFactory)(AttachmentIcon)
